import { useQuery } from '@tanstack/react-query';

import { fetchOffsetNotifications } from '../services';
import type { NotificationStatusFilter } from '../types';
import { type TimePreset, timePresetToCreatedAfter } from '../utils';

type UseOffsetNotificationListParams = {
  page: number;
  pageSize: number;
  status: NotificationStatusFilter;
  agentId?: string;
  category?: string;
  priority?: string;
  time?: TimePreset;
};

export function useOffsetNotificationList(params: UseOffsetNotificationListParams) {
  const { page, pageSize, status, agentId, category, priority, time } = params;

  return useQuery({
    queryKey: [
      'notifications',
      'offset-list',
      page,
      pageSize,
      status,
      agentId,
      category,
      priority,
      time,
    ],
    queryFn: () => {
      const is_read = status === 'read' ? true : status === 'unread' ? false : undefined;
      const created_after = time ? timePresetToCreatedAfter(time) : undefined;

      return fetchOffsetNotifications({
        limit: pageSize,
        offset: (page - 1) * pageSize,
        is_read,
        agent_id: agentId,
        category,
        priority,
        created_after,
      });
    },
  });
}
